import * as React from 'react';
import { Modal, ModalBody, ModalHeader } from '@teko/ds-mobile';
import { t } from 'i18n';
import { useThreeLevelLocationContext } from 'contexts';

export interface ModalUnAvailableTerminalProps {
  onOK?: () => void;
  oncancel?: () => void;
  showErrorUnavailableTerminal: boolean;
  setShowErrorUnavailableTerminal: (
    showErrorUnavailableTerminal: boolean,
  ) => void;
  okText?: string;
  cancelText?: string;
}

export const ModalUnAvailableTerminal = ({
  onOK,
  oncancel,
  showErrorUnavailableTerminal,
  setShowErrorUnavailableTerminal,
  okText,
  cancelText,
}: ModalUnAvailableTerminalProps) => {
  const {
    unavailableThreeLevelLocation = {
      ward: { label: '' },
      district: { label: '' },
      province: { label: '' },
    },
  } = useThreeLevelLocationContext();
  return (
    <Modal
      visible={showErrorUnavailableTerminal}
      size="s"
      okText={okText || t('Đóng')}
      onOk={() => {
        onOK?.();
        setShowErrorUnavailableTerminal(false);
      }}
      onCancel={() => {
        oncancel?.();
        setShowErrorUnavailableTerminal(false);
      }}
      okButtonProps={{ style: { width: !!cancelText ? '50%' : '100%' } }}
      cancelButtonProps={{ style: { width: !!cancelText ? '50%' : '0%' } }}
      showCloseIcon={false}
      alignFooter="center"
      cancelText={cancelText || ''}
    >
      <ModalHeader padding="s0">{t('Thông báo')}</ModalHeader>
      <ModalBody paddingLeft="s0" paddingRight="s0">
        {t(
          `Hiện tại, quý khách đang chọn nhận hàng tại: {{ward}}${
            unavailableThreeLevelLocation.district?.label
              ? `, {{district}}`
              : ''
          }, {{province}}. Rất tiếc, chúng tôi chưa phục vụ giao hàng tại khu vực này. Quý khách vui lòng chọn địa chỉ nhận hàng khác. Cảm ơn quý khách!`,
          {
            ward: unavailableThreeLevelLocation.ward.label,
            district: unavailableThreeLevelLocation.district?.label,
            province: unavailableThreeLevelLocation.province.label,
          },
        )}
      </ModalBody>
    </Modal>
  );
};
